module.exports = __webpack_public_path__ + "static/media/idai.754cd95e.png";